import { Markdown as MarkdownBase } from '@design/components/markdown';
import { Tracking } from '@terminal/services/tracking';
import { Components } from 'react-markdown';

export interface MarkdownProps {
  message: string;
  onLoad?: (element: HTMLDivElement) => void;
  components?: Partial<Components>;
  isDark?: boolean;
}

export const Markdown = ({
  message,
  onLoad,
  components,
  isDark = true,
}: MarkdownProps) => {
  const logError = (error: unknown) => {
    if (error instanceof Error) {
      Tracking.captureException(error);
    }
  };

  return (
    <MarkdownBase
      message={message}
      onLoad={onLoad}
      components={components}
      onError={logError}
      isDark={isDark}
    />
  );
};
